import { render, staticRenderFns } from "./OrderNewComponents.vue?vue&type=template&id=76637476&scoped=true&"
import script from "./OrderNewComponents.vue?vue&type=script&lang=js&"
export * from "./OrderNewComponents.vue?vue&type=script&lang=js&"
import style0 from "./OrderNewComponents.vue?vue&type=style&index=0&id=76637476&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76637476",
  null
  
)

export default component.exports